"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OWEventTypeBodyToJSON = exports.OWEventTypeBodyFromJSONTyped = exports.OWEventTypeBodyFromJSON = void 0;
function OWEventTypeBodyFromJSON(json) {
    return OWEventTypeBodyFromJSONTyped(json, false);
}
exports.OWEventTypeBodyFromJSON = OWEventTypeBodyFromJSON;
function OWEventTypeBodyFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.OWEventTypeBodyFromJSONTyped = OWEventTypeBodyFromJSONTyped;
function OWEventTypeBodyToJSON(value) {
    return value;
}
exports.OWEventTypeBodyToJSON = OWEventTypeBodyToJSON;
